module.exports = __webpack_public_path__ + "img/whatsapp_footer.4f71abbd.svg";